








































































































































































































































































































































import { defineComponent } from '@vue/composition-api'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default defineComponent({
  mounted() {
    gsap.registerPlugin(ScrollTrigger)

    // Skeleton card animations
    const scrollTrigger = {
      trigger: '#segment-bullets',
      toggleActions: 'play none none none',
      start: 'top 60%',
    }
    const tl = gsap.timeline({
      defaults: { duration: 1, opacity: 0 },
      scrollTrigger,
    })
    const tl2 = gsap.timeline({
      defaults: { duration: 1.5, delay: 2 },
      scrollTrigger,
    })

    tl.set('#skeleton-bullets-rectangle-front, #skeleton-bullets-rectangle-back', { visibility: 'visible' })
    tl.from('#skeleton-bullets-rectangle-front', { y: 50, opacity: 0, duration: 0.5 })
    tl.from('#skeleton-bullets-rectangle-back', { y: 50, opacity: 0, duration: 0.5 })
    tl.set(
      '#skeleton-bullets-card-bg, #skeleton-bullets-card-stroke, #skeleton-bullets-card-text, #skeleton-bullets-card-text-prominent, #skeleton-bullets-card-icons',
      {
        visibility: 'visible',
      }
    )
    tl.from('#skeleton-bullets-card-bg', { scaleX: 0, transformOrigin: 'left', ease: 'back.out(1)', stagger: 0.05 })
    tl.from('#skeleton-bullets-card-stroke', { scaleY: 0, transformOrigin: 'top', stagger: 0.05 }, '-=1')
    tl.from(
      '#skeleton-bullets-card-text',
      { scaleX: 0, transformOrigin: 'left', ease: 'back.out(1.5)', stagger: 0.05 },
      '-=1.5'
    )
    tl.from('#skeleton-bullets-card-text-prominent', { stagger: 0.3 }, '-=1.5')
    tl.from('#skeleton-bullets-card-icons', { stagger: 0.3 }, '-=1.5')

    tl2.to('#skeleton-bullets-whole-card', { y: -5, repeat: -1, yoyo: true, stagger: 0.5 })
    tl2.to('#skeleton-bullets-rectangle-back', { x: -5, repeat: -1, yoyo: true })
  },
})
